// extracted by mini-css-extract-plugin
export default {"promo":"Promo-module__promo___s7TUt"};